module.exports = __webpack_public_path__ + "img/welcomes-preview-no-vip-2.bf86e868.png";